<div style="position: relative;">
  <div id="busy-overlay" class="component-overlay" *ngIf="isBusy">
    <div class="center">
      <mat-spinner color="accent" [diameter]="48"></mat-spinner>
    </div>
  </div>
  <button mat-button *ngIf="!hasProjectPreperationSection" color="accent" (click)="initializeSection()">
    <mat-icon>add</mat-icon>
    PROJEKTABWICKLUNGSKOSTEN HINZUFÜGEN
  </button>
  <div [hidden]="!hasProjectPreperationSection" style="margin-top: 24px;">
    <app-entries-table #projectPreperationTable 
                       [productsDataSource]="products"
                       [originalEntries]="projectPreperationSection"
                       [publishTotalCosts]="true"
                       (discardChangesCalled)="discardChanges()"
                       (saveChangesCalled)="saveChanges($event)"
                       (deleteCalled)="deleteSection()"></app-entries-table>
  </div>
</div>

